export let cancelButton = "i22xIc";
export default {cancelButton};